import { render } from "./AdminDashboard.vue?vue&type=template&id=1967c12a&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=1967c12a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1967c12a"]])

export default __exports__